<div class="wpx_wrap">
    <div class="header-content">
        <nav class="nav nav-pills flex-column flex-sm-row menu-desktop">
            <a class="flex-sm-fill nav-link" href="{{ environment.data.vitrineUrl }}">
                <img src="./assets/images/menu/prixtel/logo_prixtel.svg">
            </a>

            <div class="menu-grid">
                <a class="flex-sm-fill text-sm-center nav-link" href="{{ environment.data.vitrineUrl }}/forfait-mobile">
                    Forfaits mobiles
                </a>
                <a class="flex-sm-fill text-sm-center nav-link" href="{{ environment.data.vitrineUrl }}/qui-sommes-nous">
                    Qui sommes-nous ?
                </a>
            </div>

            <a class="flex-sm-fill text-sm-right nav-link assistance" href="{{ environment.data.assistanceUrl }}">
                <img class="chat" src="./assets/images/menu/prixtel/chat.svg">
            </a>
        </nav>
        <div class="menu-mobile">
            <a class="logo" href="{{ environment.data.vitrineUrl }}">
                <img src="./assets/images/menu/prixtel/logo_prixtel.svg">
            </a>
            <a class="assistance" href="{{ environment.data.assistanceUrl }}">
                <img class="chat" src="./assets/images/menu/prixtel/chat.svg">
            </a>
        </div>
    </div>
</div>
